import { CiudadParametroImpositivo } from './CiudadParametroImpositivo';
import { ParametroImpositivoDetalle } from './ParametroImpositivoDetalle';
import { TipoPadronV2 } from '@shared/enums/tiposPadronV2';

export class ProvinciaParametroImpositivo {
    provinciaId: string;
    provinciaNombre: string;
    provinciaCodigo: string;
    tipoPadron: TipoPadronV2;
    tipoPadronCombustible: TipoPadronV2;
    parametros: ParametroImpositivoDetalle[];
    ciudades:CiudadParametroImpositivo[];
}